<template>
    <transition>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Accounts </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Receive Payment</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-dark float-right" @click="redirectRoute('/accounting/voucher-list')">
                              <i class="mdi mdi-arrow-left-thin"></i> Back
                            </button>  -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 ">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3 mb-3">
                                    <div class="form-check">
                                        <input type="radio" id="doctor_service_collection" name="form_type" class="form-check-input" value="DSC" checked @change="onChangeReceivePaymentForm($event)">
                                        <label class="form-check-label" for="doctor_service_collection" style="font-size: 18px; font-weight: bold;">Doctor Service</label>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3">
                                    <div class="form-check">
                                        <input type="radio" id="pos_sales_collection" name="form_type" class="form-check-input" value="PSC" @change="onChangeReceivePaymentForm($event)"> 
                                        <label class="form-check-label" for="pos_sales_collection" style="font-size: 18px; font-weight: bold;">Sales Collection</label>
                                    </div>
                                </div>
                                <div class="col-md-6"></div>

                                <hr>
                            </div>

                            <div id="doctor_service_collection_form" v-if="is_dsc_form && !loading">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">

                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="department_id">Department *</label><br>
                                                    <Multiselect
                                                        class="form-control border department_id"
                                                        mode="single"
                                                        v-model="doctor_service_form.department_id"
                                                        placeholder="Select Department"
                                                        @change="onkeyPress('department_id'), onChangeDepartment($event)"   
                                                        :searchable="true" 
                                                        :filter-results="true"
                                                        :options="department_options"
                                                        :classes="multiclasses"
                                                        :close-on-select="true" 
                                                        :min-chars="1"
                                                        :resolve-on-load="false"
                                                        :hide-selected="true" 
                                                    />
                                                    <div class="invalid-feedback" v-if="errors.department_id">
                                                        {{ errors.department_id }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="doctor_id">Doctor *</label><br>
                                                    <Multiselect
                                                        class="form-control border supplier_id"
                                                        mode="single"
                                                        v-model="doctor_service_form.doctor_id"
                                                        placeholder="Select Doctor"
                                                        @change="onkeyPress('doctor_id'), onChangeDoctor($event)"   
                                                        :searchable="true" 
                                                        :filter-results="true"
                                                        :options="doctor_options"
                                                        :classes="multiclasses"
                                                        :close-on-select="true" 
                                                        :min-chars="1"
                                                        :resolve-on-load="false"
                                                        :hide-selected="true" 
                                                    />
                                                    <div class="invalid-feedback" v-if="errors.doctor_id">
                                                        {{ errors.doctor_id }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="patient_id">Patient *</label><br>
                                                    <Multiselect
                                                        class="form-control border supplier_id"
                                                        mode="single"
                                                        v-model="doctor_service_form.patient_id"
                                                        placeholder="Select Patient"
                                                        @change="onkeyPress('patient_id'), onChangePatient($event)"   
                                                        :searchable="true" 
                                                        :filter-results="true"
                                                        :options="patient_options"
                                                        :classes="multiclasses"
                                                        :close-on-select="true" 
                                                        :min-chars="1"
                                                        :resolve-on-load="false"
                                                        :hide-selected="true" 
                                                    />
                                                    <div class="invalid-feedback" v-if="errors.patient_id">
                                                        {{ errors.patient_id }}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    
                                    <!-- <div class="col-md-6">
                                        <div class="mb-1">
                                            <label for="search_id">Scan Barcode </label><br>
                                            <div class="form-group autocomplete">
                                                <input
                                                    type="text"
                                                    id="search_id"
                                                    v-model="searchIteam"
                                                    class="form-control"
                                                    placeholder="Scan/Search Appointment by ID"
                                                    @keyup="inputChanged"
                                                />
                                                <div class="invalid-feedback" v-if="errors.searchIteam">
                                                    {{ errors.searchIteam }}
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

                                </div>

                                <div class="service_field">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <table class="table table-responsive table-centered">
                                                <thead>
                                                    <tr>
                                                        <th width="60%">Service</th>
                                                        <th width="35%">Amount</th>
                                                        <th width="5%"></th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="doctor_service_form.services.length > 0">
                                                    <tr v-for="(item, i) in doctor_service_form.services" :key="i">
                                                        <td>
                                                            <treeselect 
                                                                v-model="item.ledger_id"
                                                                :multiple="false" 
                                                                :always-open="false"
                                                                :options="accounts"
                                                                :normalizer="normalizer"
                                                                :disable-branch-nodes="true"
                                                                :value-consists-of="valueConsistsOf"
                                                                :default-expand-level="Infinity"
                                                                :search-nested="true"
                                                                @select="onkeyPress('ledger_id')"                                                
                                                                placeholder='Select Doctor Service account'
                                                                v-if="renderOptionComponent"
                                                            />
                                                            <div class="invalid-feedback" v-if="errors.ledger_id">
                                                                {{ errors.ledger_id }}
                                                            </div>                                         
                                                        </td>
                                                        <td>
                                                            <input type="number" step="any" class="form-control border" v-model="item.ledger_amount" @input="onkeyPress('ledger_amount')" @click="addNewService($event, i)">
                                                            <div class="invalid-feedback" v-if="errors.ledger_amount">
                                                                {{ errors.ledger_amount }}
                                                            </div>
                                                        </td>
                                                        <td class="text-right">
                                                            <a href="javascript:void(0)" class="text-danger" @click="removeServiceRow(i)" v-if="i > 0"><i class="mdi mdi-close-outline"></i></a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>                          
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="invoice_table">
                                        <table class="table table-bordered table-centered table-nowrap w-100">
                                            <thead class="table-light">
                                                <tr class="border success item-head">
                                                    <!-- <th class="text-center" style="width: 5%;"><input type="checkbox" v-model="check_all_item" @change="checkAllAppointment"></th> -->
                                                    <th class="text-center" style="width: 20%">Appointment ID </th> 
                                                    <th class="text-center" style="width: 15%">Receivable Amount </th> 
                                                    <th class="text-center" style="width: 15%">Receive Amount</th>
                                                    <th class="text-center" style="width: 15%">Paid Amount</th>
                                                    <th class="text-center" style="width: 15%">Balance Amount</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-for="(item, i) in doctor_service_form.items" :key="i" >
                                                    <!-- <td class="text-center">
                                                        <input type="checkbox" v-model="item.checked" @change="checkSingleItem">
                                                    </td> -->
                                                    <td>
                                                        {{ item.appointment_auto_id }}
                                                    </td>
                                                    <td class="text-right">
                                                        <input type="number" step="any" class="form-control border" :style="item.item_css" v-model="item.receivable_amount" @input="totalCalculateAmount($event, i, 'receivable')">
                                                    </td>

                                                    <td class="text-right">
                                                        {{ parseFloat(Number(item.receive_amount)).toFixed(2) }}
                                                    </td>
                                                    <!-- <td>                                                        
                                                       <input type="number" step="any" class="form-control border" v-model="item.adjust_amount">
                                                    </td> -->
                                                    <td class="text-right"> 
                                                        <input type="number" step="any" class="form-control border" :style="item.item_css" v-model="item.paid_amount" @input="totalCalculateAmount($event, i, 'paid')">
                                                    </td>
                                                    <td class="text-right">{{  parseFloat(Number(item.receivable_amount)) - (parseFloat(Number(item.receive_amount)) + parseFloat(Number(item.paid_amount))) }}</td>
                                                    <!-- <td class="text-center">
                                                        <a href="javascript:void(0)" class="text-danger" style="font-size: 18px;" @click="removeAccountItem(i)"> <i class="mdi mdi-delete-outline"></i></a>
                                                    </td> -->
                                                </tr>
                                            </tbody>

                                            <tfoot>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <td class="bg-success text-right">{{ Number(doctor_service_form.total_paid_amount).toFixed(2) }}</td>
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="mb-3">
                                            <label for="payment_type">Payment Type *</label><br>
                                            <Multiselect
                                                class="form-control border payment_type"
                                                mode="single"
                                                v-model="doctor_service_form.payment_type"
                                                placeholder="Select Payment Type"
                                                @change="onkeyPress('payment_type'), onChangePaymentType($event)"   
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="payment_type_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false"
                                                :hide-selected="true" 
                                            />
                                            <div class="invalid-feedback" v-if="errors.payment_type">
                                                {{ errors.payment_type }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-9" v-if="is_cheque">
                                        <div class="row cheque_form">
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="bank_account_id">Bank Account *</label><br>
                                                    <Multiselect
                                                        class="form-control border bank_account_id"
                                                        mode="single"
                                                        v-model="doctor_service_form.bank_account_id"
                                                        placeholder="Select Bank Account"
                                                        @change="onkeyPress('bank_account_id')"   
                                                        :searchable="true" 
                                                        :filter-results="true"
                                                        :options="bank_account_options"
                                                        :classes="multiclasses"
                                                        :close-on-select="true" 
                                                        :min-chars="1"
                                                        :resolve-on-load="false"
                                                        :hide-selected="true" 
                                                    />
                                                    <div class="invalid-feedback" v-if="errors.bank_account_id">
                                                        {{ errors.bank_account_id }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="cheque_no" style="margin-bottom: 0;">Cheque No</label>
                                                    <input type="text" class="form-control border" v-model="doctor_service_form.cheque_no" @input="onkeyPress('cheque_no')">
                                                    <div class="invalid-feedback" v-if="errors.cheque_no">
                                                        {{ errors.cheque_no }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="cheque_date" style="margin-bottom: 0;">Cheque Date</label>
                                                    <input type="date" class="form-control border" v-model="doctor_service_form.cheque_date" @input="onkeyPress('cheque_date')">
                                                    <div class="invalid-feedback" v-if="errors.cheque_date">
                                                        {{ errors.cheque_date }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label for="receive_notes" style="margin-bottom: 0;">Payment Details</label>
                                            <textarea class="form-control border" rows="1" v-model="doctor_service_form.receive_notes" @input="onkeyPress('receive_notes')" placeholder="Write payment receive notes"></textarea>
                                            <div class="invalid-feedback" v-if="errors.receive_notes">
                                                {{ errors.receive_notes }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="buttons" style="text-align: right;">
                                            <button type="button" class="btn btn-primary " @click.prevent="submitDoctotServicePaymentReceive()" :disabled="disabled">
                                                <span v-show="isSubmit">
                                                    <i class="fas fa-spinner fa-spin" ></i>
                                                </span> Submit 
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row"> 
                                <div class="col-md-5">  
                                </div>
                                <div class=" col-md-2"> 
                                    <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                </div>
                                <div class="col-md-5">  
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>        
        </div>
    </transition>
</template>
<script>
import Modal from "./../helper/Modal";
import { ref, onMounted } from "vue";
import axios from 'axios';
import Form from 'vform';
import { json } from "body-parser";

export default {
    name: 'PosLeftbar',
    components: {
        Modal
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            disabled: true,
            showModal: false,
            modalActive:false,
            errors: {},
            doctor_service_form: new Form({
                date: new Date().toISOString().slice(0,10),
                department_id: '',
                doctor_id: '',
                patient_id: '',
                services: [{
                    ledger_id: null,
                    ledger_amount: '',
                }],
                items: [],
                total_paid_amount: 0.00,
                payment_type: 'cash',
                bank_account_id: '',
                cheque_no: '',
                // cheque_date: new Date().toISOString().slice(0,10),
                cheque_date: '',
                receive_notes: '',
            }),
            doctor_service_form_validate: true,
            departments: [],
            department_options: [],
            doctors: [],
            doctor_options: [],
            patients: [],
            patient_options: [],
            appointment_id: this.$route.query.appointment_id,
            appointments: [],
            appointments_by_doctor: [],
            payment_type_options: [{label: 'Cash', value: 'cash'}, {label: 'Cheque', value: 'cheque'}],
            bank_accounts: [],
            bank_account_options: [],
            accounts: [],
            renderOptionComponent: true,
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id +'___'+node.code,
                    label: '['+ node.code +'] '+ node.name,
                    children: node.children,
                }
            },
            is_dsc_form: true,
            is_psc_form: false,
            is_cash: true,
            is_cheque: false,
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },
        };
    },
    created() {
        if(this.appointment_id != '') {
            this.createPaymentReceive(this.appointment_id);
        }else{
            this.createPaymentReceive();
        }
        this.fetchAccountLedgers();
    },
    methods: {
        redirectRoute: function(route_link) {
            
        },

        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        createPaymentReceive(id = '') {
            this.doctor_service_form.items = [];
            axios.get(this.apiUrl+'/accounts/payment_receive/create', {
                headers: this.headerparams,
                params: {
                    appointment_id: id
                }
            })
            .then((resp) => {
                // console.log("resp===>", resp);
                this.departments = resp.data.data.departments;
                this.doctors = resp.data.data.doctors;
                this.patients = resp.data.data.patients;
                this.appointments = resp.data.data.appointments;
                this.appointments_by_doctor = resp.data.data.appointments_by_doctor;
                this.bank_accounts = resp.data.data.bank_accounts;

                this.department_options = resp.data.data.departments.map((item) => {
                    return {label: item.name, value: item.id};
                });

                if(id != '') {
                    var department_id = resp.data.data.appointments[0].department_id;
                    var doctor_id = resp.data.data.appointments[0].doctor_id;
                    var patient_id = resp.data.data.appointments[0].patient_id;

                    this.doctor_service_form.department_id = department_id;
                    var data_doctors = this.doctors.filter(item => item.department_id == department_id) ?? [];
                    this.doctor_options = data_doctors.map((item) => {
                        return {label: item.first_name + ' ' + item.last_name, value: item.id};
                    });

                    this.doctor_service_form.doctor_id = doctor_id;
                    var data_patient_appointments = this.appointments_by_doctor[doctor_id] ?? {};
                    var patient_ids = [];
                    if(Object.keys(data_patient_appointments).length > 0) {
                        patient_ids = Object.keys(data_patient_appointments)
                    }

                    let patientData = this.patients.filter(item => patient_ids.includes(item.id.toString()));
                    this.patient_options = patientData.map((item) => {
                        return {label: item.name + ' - ' + item.phone, value: item.id};
                    });

                    this.doctor_service_form.patient_id = patient_id;
                    this.doctor_service_form.items = this.appointments_by_doctor[doctor_id][patient_id] ?? [];

                }

            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        fetchAccountLedgers() {
            axios.get(this.apiUrl+'/account_ledgers/getChartOfAccountsOption', this.headerjson)
            .then((resp) => {
                this.accounts = resp.data.data.accounts;  
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message)
            })
            .finally(() => {
                this.loading = false;
            });
        },

        
        onChangeReceivePaymentForm (event) {
            var formType = event.target.value;
            if(formType ==  "DSC") {
                this.is_dsc_form = true;
                this.is_psc_form = false;
            } else if(formType ==  "PSC") {
                this.is_dsc_form = false;
                this.is_psc_form = true;
            }
        },

        onChangeDepartment: function(event) {
            this.doctor_service_form.items = [];
            var department_id = event;
            if(department_id != '') {
                var data_doctors = this.doctors.filter(item => item.department_id == department_id) ?? [];
                this.doctor_options = data_doctors.map((item) => {
                    return {label: item.first_name + ' ' + item.last_name, value: item.id};
                });
            }else{
                this.$toast.error('Please Select Department');
            }
        },

        onChangeDoctor: function(event) {
            this.doctor_service_form.items = [];
            var doctor_id = event;
            if(doctor_id != '') {
                var data_patient_appointments = this.appointments_by_doctor[doctor_id] ?? {};
                var patient_ids = [];
                if(Object.keys(data_patient_appointments).length > 0) {
                    patient_ids = Object.keys(data_patient_appointments)
                }

                let patientData = this.patients.filter(item => patient_ids.includes(item.id.toString()));
                this.patient_options = patientData.map((item) => {
                    return {label: item.name + ' - ' + item.phone, value: item.id};
                });
                
            }else{
                this.$toast.error('Please Select Doctor');
            }
        },

        onChangePatient: function(event) {
            this.doctor_service_form.items = [];
            var patient_id = event;
            if(patient_id != '') {
                this.doctor_service_form.items = this.appointments_by_doctor[this.doctor_service_form.doctor_id][patient_id] ?? [];
            }else{
                this.$toast.error('Please Select Patient');
            }
        },

        addNewService(value, index, change_field="") {
            var item_length = this.doctor_service_form.services.length;
            if(index == (item_length - 1)) {

                var exists_data = this.doctor_service_form.services.find(({ledger_id}) => ledger_id == value) ?? '';
                if(exists_data == '') {
                    this.doctor_service_form.services.push(
                        {
                            ledger_id: null,
                            ledger_amount: ''
                        }
                    );
                }

            }
        },
        removeServiceRow(index) {
            this.doctor_service_form.services.splice(index, 1);
        },

        onChangePaymentType: function(event) {
            this.bank_account_options = [];
            this.doctor_service_form.bank_account_id = '';
            this.doctor_service_form.cheque_no = '';
            this.doctor_service_form.cheque_date = '';
            var paymentType = event;
            if(paymentType == "cash") {
                this.is_cash = true;
                this.is_cheque = false;
            }else if(paymentType == "cheque") {
                this.is_cash = false;
                this.is_cheque = true;
                this.bank_account_options = this.bank_accounts.map((item) => {
                    return {label: item.bank_name + ' (' + item.account_no + ')' , value: item.id};
                });
            }
        },

        totalCalculateAmount: function(event, index, type) {
            if(type == "receivable") {
                this.doctor_service_form.total_receivable_amount = this.doctor_service_form.items.reduce((a, b) => a + parseFloat(b.receivable_amount), 0);
            }else if(type == "paid") {
                this.doctor_service_form.total_paid_amount = this.doctor_service_form.items.reduce((a, b) => a + parseFloat(b.paid_amount != '' ? b.paid_amount : 0), 0);
                var item_total_receive_amount = parseFloat(this.doctor_service_form.items[index].receive_amount + this.doctor_service_form.items[index].paid_amount);
                if(this.doctor_service_form.items[index].receivable_amount < item_total_receive_amount) {
                    this.doctor_service_form.items[index].paid_amount = parseFloat(this.doctor_service_form.items[index].receivable_amount - this.doctor_service_form.items[index].receive_amount);
                }                
            }
        },

        // For Doctor Service Form Submit
        submitDoctotServicePaymentReceive: function() {
            var service_amount = this.doctor_service_form.services.reduce((a, b) => a + parseFloat(b.ledger_amount != '' && b.ledger_amount > 0 ? b.ledger_amount : 0), 0);
            if(this.doctor_service_form.total_paid_amount < service_amount || this.doctor_service_form.total_paid_amount > service_amount) {
                this.$toast.error('Total service amount and total paid amount should be same');
                return false;
            }

            this.isSubmit = true;
            this.disabled = true;

            var formData    = new FormData();
            formData.append("date", this.doctor_service_form.date);
            formData.append("department_id", this.doctor_service_form.department_id);
            formData.append("doctor_id", this.doctor_service_form.doctor_id);
            formData.append("patient_id", this.doctor_service_form.patient_id);
            formData.append("service_items", JSON.stringify(this.doctor_service_form.services));
            formData.append("appointment_items", JSON.stringify(this.doctor_service_form.items));
            formData.append("total_paid_amount", this.doctor_service_form.total_paid_amount);
            formData.append("payment_type", this.doctor_service_form.payment_type);
            formData.append("bank_account_id", this.doctor_service_form.bank_account_id);
            formData.append("cheque_no", this.doctor_service_form.cheque_no);
            formData.append("cheque_date", this.doctor_service_form.cheque_date);
            formData.append("receive_notes", this.doctor_service_form.receive_notes);

            axios.post(this.apiUrl+'/accounts/payment_receive', formData, this.headers)
            .then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.doctor_service_form.reset();
                    this.forceRerender();
                    this.createPaymentReceive();
                    this.$toast.success(res.data.message);
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            })
            .finally(() => {
                this.isSubmit = false;
                this.disabled = false;
            });

        }, 

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        }, 

        inputChanged: function() {

        },

    },

    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {

        totalDebitAmount: function(){ 
            return this.vform.account_items.reduce(function(total, item){
                var debit_amount = (item.debit != '') ? item.debit : 0;
                return parseFloat(total + parseFloat(debit_amount)); 
            },0);
        }, 
        totalCreditAmount: function() {
            return this.vform.account_items.reduce(function(total, item) {
                var credit_amount = (item.credit != '') ? item.credit : 0;
                return parseFloat(total + parseFloat(credit_amount)); 
            },0);
        },
    },
    watch: {
        'doctor_service_form.items': {
            handler: function(val, oldVal) {
                if(val.length > 0){
                    this.disabled = false;
                }else{
                    this.disabled = true;
                }
            },
            deep: true
        },
    }
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 90%;
    display: block;
    margin: 0 auto;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.actions a{
    margin-right: 5px;
}
</style>